import { atomWithKey as atom } from "./atomWithKey";

export type ModalStateTicket = {
    isVisible: boolean,
    bookingId: string
}

export type ModalStateRequestInvoice = {
    isVisible: boolean,
    bookingId: string,
    bookingRef: string
}

export const currentPassengerTicketAtom = atom<number>({
    key: "currentPassengerTicketAtom",
    default: 0
});

export const currentOfferIndexTicketAtom = atom<number>({
    key: "currentOfferIndexTicketAtom",
    default: 0
});

export const currentLegIndexTicketAtom = atom<number>({
    key: "currentLegIndexTicketAtom",
    default: 0
});

export const modalStateTicketAtom = atom<ModalStateTicket>({
    key: 'modalStateTicketAtom',
    default: {
        isVisible: false,
        bookingId: ""
    }
})

export const modalStateRequestInvoiceAtom = atom<ModalStateRequestInvoice>({
    key: 'modalStateRequestInvoiceAtom',
    default: {
        isVisible: false,
        bookingId: "",
        bookingRef: ""
    }
})